export default __webpack_public_path__ + "static/media/report.41b8d2b8.svg";